import React from 'react';
import {Link} from 'react-router-dom';

class CategoryItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="item-category-S">
        <Link to={'/category/' + this.props.id} className='item-category-S-title'><i className={this.props.smallIcon != 'icon' ? this.props.smallIcon : 'vtd-star'}/>{this.props.name}</Link>
        <div className='category-list-sub-item-S'>
          {
            this.props.children.map((item, i) => {
              return(
                <div className='sub-category-S' key={i}>
                  <Link to={'/list-products/' + item.id} className='sub-category-S-link'>{item.name}&nbsp;{'('+item.amount?item.amount:null+')'}</Link>
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }
}

export default CategoryItem;



// WEBPACK FOOTER //
// ./components/all-categories/CategoryItem.jsx